import { createReducer } from '@reduxjs/toolkit';
import { setSelectedTask } from 'store/actions';

export { default as appState } from 'store/app';

export const selectedTask = createReducer(null, {
  [setSelectedTask]: (state, action) => (state = action.payload),
});

export { default as clientTxnOppsState } from 'store/clientTxnOpps';
export { default as channelWorkflowState } from 'store/underwrite/channelWorkflow';
export { default as propertyUWState } from 'store/underwrite/propertyUW';
export { default as auctionUWState } from 'store/underwrite/auctionUW';
export { default as queueState } from 'store/queue';
export { default as importState } from 'store/import/import';
export { default as searchState } from 'store/search';
export { default as exploreData } from 'store/explore/data';
export { default as exploreShapesData } from 'store/explore/shapesData';
export { default as exploreMap } from 'store/explore/map';
export { default as exploreViews } from 'store/explore/views';
export { default as exploreLoading } from 'store/explore/loading';
export { default as exploreProspects } from 'store/explore/prospects';
export { default as dashboardState } from 'store/dashboard';
export { default as adminState } from 'store/admin';
export { default as opportunityHistoryState } from 'store/underwrite/opportunityHistory';
export { default as assumptionModulesState } from 'store/assumptions/assumptionModules';
export { default as assumptionGroupsState } from 'store/assumptions/assumptionGroups';
export { default as assumptionGridState } from 'store/assumptions/assumptionGrid';
export { default as assumptionMapState } from 'store/assumptions/assumptionMap';
export { default as postAcqUWState } from 'store/postAcq/postAcqUW';
export { default as postAcqWorkflowState } from 'store/postAcq/postAcqWorkflow';
